<script>
import IMask from 'imask';

export default {
  props: {
    value: {},
    options: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    iMask: null,
    focus: false,
  }),
  computed: {
    el() {
      return this.$refs.input;
    },
    __valueType() {
      switch (this.type) {
        case 'typed':
        case 'typedValue':
          return 'typedValue';
        case 'unmasked':
        case 'unmaskedValue':
          return 'unmaskedValue';
        default:
          return 'value';
      }
    },
    __value: {
      get() {
        return this.iMask[this.__valueType];
      },
      set(value) {
        this.iMask[this.__valueType] = value;
      },
    },
  },
  watch: {
    value(v) {
      this.__value = v;
    },
    options() {
      this.update();
    },
  },
  methods: {
    update() {
      this.iMask.updateOptions(this.options);
    },
    handlerBlur() {
      this.$emit('blur');
      if (this.focus) {
        this.$emit('input', this.__value);
        this.$emit('change', this.__value);
      }
      if (!this.__value) {
        this.__value = '';
      }
      this.focus = false;
    },
    handlerFocus() {
      this.focus = true;
      this.$emit('focus');
    },
    handlerSubmit() {
      this.el.blur();
      this.$emit('submit');
    },
  },
  mounted() {
    this.iMask = IMask(this.$refs.input, this.options);
    this.iMask.on('accept', () => {
      if (!this.focus) {
        return;
      }
      this.$emit('input', this.__value);
      this.update();
    });
    this.__value = this.value;
  },
};
</script>
<template>
  <input
    ref="input"
    type="text"
    class="f-c-input"
    :disabled="disabled"
    @blur="handlerBlur"
    @focus="handlerFocus"
    @keypress.enter="handlerSubmit"
  >
</template>
